module.exports = __webpack_public_path__ + "img/logo.1b83d475.svg";